import { defineMessages } from 'react-intl'

const scope = `procurify.budgets.components.BudgetCustomFieldValueSelect`

export default defineMessages({
  noCustomFieldPlaceholder: {
    id: `${scope}.noCustomFieldPlaceholder`,
    defaultMessage: 'Select a custom field first',
  },
  checkboxCheckedLabel: {
    id: `${scope}.checkboxCheckedLabel`,
    defaultMessage: 'Yes',
  },
  checkboxUncheckedLabel: {
    id: `${scope}.checkboxUncheckedLabel`,
    defaultMessage: 'No',
  },
  inactiveValueLabel: {
    id: `${scope}.inactiveValueLabel`,
    defaultMessage: '{value} (inactive)',
  },
})
